import { PartyBookingFlow } from '_organisms';
import React from 'react';

const Parties: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-lg md:text-3xl font-bold text-gray-900 mb-2">
          Party Packages
        </h1>
        <p className="text-gray-600">
          Select your party package and complete your booking
        </p>
      </div>
      <PartyBookingFlow />
    </div>
  );
};

export default Parties;
